import { DateTime } from "luxon";
import type { FC } from "react";
import React from "react";

import { Logo } from "../../../shared/components/Logo.tsx";

import { CrumbChip } from "./CrumbChip.tsx";

function getTodayLabel(): string {
  // oxlint-disable-next-line no-warning-comments
  // TODO(APT-245): read "now" from a shared reactive context.
  const now = DateTime.now().setLocale("en-US");

  return now.toFormat("EEE · MMM d").toUpperCase();
}

export const Header: FC = () => (
  <header
    className="grid grid-cols-[1fr_auto_1fr] items-center border-b bg-background/95 px-4 py-3 backdrop-blur-sm"
    style={{ paddingTop: "max(var(--safe-top, 0px), 0.75rem)" }}
  >
    <div className="flex items-center gap-[5px]">
      <Logo className="size-[15px] shrink-0 text-foreground" />
      <span className="text-[13px] font-bold tracking-[-0.015em] whitespace-nowrap">
        <span>Calorie</span> <span className="text-primary">Grid</span>
      </span>
    </div>
    <span className="text-[13px] font-semibold tracking-[0.04em] whitespace-nowrap">
      {getTodayLabel()}
    </span>
    <div className="flex justify-end">
      <CrumbChip />
    </div>
  </header>
);
